module.exports = __webpack_public_path__ + "img/组 8737@2x.a79fb66f.png";